import { getAuth } from "firebase/auth";

// Global impersonation state
let impersonatingUserId: string | null = null;

// Function to set impersonation
export function setImpersonation(userId: string | null) {
  impersonatingUserId = userId;
}

// Function to get current impersonation
export function getImpersonation() {
  return impersonatingUserId;
}

export async function authenticatedFetch(
  url: string,
  options: RequestInit = {}
) {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("No authenticated user");
  }

  const token = await user.getIdToken();
  
  const headers = new Headers(options.headers);
  headers.set("Authorization", `Bearer ${token}`);
  headers.set("Content-Type", "application/json");
  
  // Add impersonation header if impersonating
  if (impersonatingUserId) {
    headers.set("x-impersonate-user", impersonatingUserId);
  }

  return fetch(url, {
    ...options,
    headers,
  });
}
